export default __webpack_public_path__ + "static/media/mdi_bag-personal-outline.1f7f1a5a.svg";